import React, { useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  ListGroup,
  Row,
  Table,
} from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";
import {
  FaCircleCheck,
  FaCircleInfo,
  FaCircleXmark,
  FaRegCircleXmark,
} from "react-icons/fa6";
import { TbTableOptions } from "react-icons/tb";
import { NavLink } from "react-router-dom";
import SEOReportGraph from "./SEOReportGraph";

const OnePageSEOChecker = () => {
  const [openSolutions, setOpenSolutions] = useState("");

  return (
    <>
      <Container fluid className="bg-light">
        <Row>
          <Form.Group
            as={Col}
            xs={12}
            md={9}
            className="border-end overflow-auto"
            style={{ height: "calc(100vh - 56px)" }}
          >
            <div className="pt-3">
              <div className="hstack justify-content-center gap-3 flex-wrap">
                <div className="position-relative">
                  <img
                    src="http://192.168.1.10:3002/static/media/computer-mockup.8d5a68a668905a9f878b.png"
                    style={{ height: 300 }}
                  />
                  <img
                    src="http://192.168.1.10:3002/static/media/computer-mockup-screenshot.407d571482fe4284493c.png"
                    className="position-absolute"
                    style={{
                      height: 126,
                      top: 59,
                      left: 39,
                      width: 222,
                      objectFit: "fill",
                    }}
                  />
                </div>
                <div className="position-relative">
                  <img
                    src="http://192.168.1.10:3002/static/media/tablet-mockup-device.7afa1d2a0af15d5b5b87.jpg"
                    style={{ height: 300 }}
                  />
                  <img
                    src="http://192.168.1.10:3002/static/media/tablet-mockup-screen.3d499866f0d38f2b66f8.png"
                    className="position-absolute"
                    style={{
                      height: 202,
                      top: 49,
                      left: 69,
                      width: 161,
                      objectFit: "fill",
                    }}
                  />
                </div>
                <div className="position-relative">
                  <img
                    src="http://192.168.1.10:3002/static/media/mobile-mockup.e9538f8558cd3cf7a87e.png"
                    style={{ height: 300 }}
                  />
                  <img
                    src="http://192.168.1.10:3002/static/media/mobile-mockup-screen.7da75dde0f6c8cc65d88.png"
                    className="position-absolute"
                    style={{
                      height: 241,
                      top: 29,
                      left: 91,
                      width: 118,
                      objectFit: "fill",
                      borderRadius: 14,
                    }}
                  />
                </div>
              </div>
            </div>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> Issues overview
              </Card.Header>
              <Card.Body className="p-0">
                <ListGroup className="border-bottom rounded-0">
                  <ListGroup.Item
                    action
                    className="border-0 hstack py-1"
                    style={{ fontSize: 12 }}
                  >
                    <div className="hstack gap-1" style={{ minWidth: 200 }}>
                      <FaRegCircleXmark className="text-danger" /> H1 tag
                    </div>
                    <span>H1 tag not found</span>
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    className="border-0 hstack py-1"
                    style={{ fontSize: 12 }}
                  >
                    <div className="hstack gap-1" style={{ minWidth: 200 }}>
                      <FaRegCircleXmark className="text-danger" /> Description
                      check
                    </div>
                    <span>Description tag not found</span>
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    className="border-0 hstack py-1"
                    style={{ fontSize: 12 }}
                  >
                    <div className="hstack gap-1" style={{ minWidth: 200 }}>
                      <FaRegCircleXmark className="text-danger" /> Title length
                    </div>
                    <span>9 characters (Recommended: 35-65 characters)</span>
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    className="border-0 hstack py-1"
                    style={{ fontSize: 12 }}
                  >
                    <div className="hstack gap-1" style={{ minWidth: 200 }}>
                      <FaRegCircleXmark className="text-danger" /> Mobile
                      PageSpeed Insights
                    </div>
                    <span>33</span>
                  </ListGroup.Item>
                </ListGroup>
                <div className="py-2 px-3">
                  <Form.Label className="mb-1 fw-bold fs-12">
                    Warnings
                  </Form.Label>
                </div>
                <ListGroup className="rounded-0">
                  <ListGroup.Item
                    action
                    className="border-0 hstack py-1"
                    style={{ fontSize: 12 }}
                  >
                    <div className="hstack gap-1" style={{ minWidth: 200 }}>
                      <FaCircleInfo className="text-warning me-1" /> Text to
                      code ratio
                    </div>
                    <span>1% (Recommended: more than 10%)</span>
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    className="border-0 hstack py-1"
                    style={{ fontSize: 12 }}
                  >
                    <div className="hstack gap-1" style={{ minWidth: 200 }}>
                      <FaCircleInfo className="text-warning me-1" /> Link with
                      3xx status code
                    </div>
                    <Form.Group>
                      <NavLink
                        to={"https://martcost.com/my-account/downloads/"}
                      >
                        https://martcost.com/my-account/downloads/ (found 1)
                      </NavLink>
                      <br />
                      <NavLink to={"https://martcost.com/my-account/orders/"}>
                        https://martcost.com/my-account/orders/ (found 1)
                      </NavLink>
                      <br />
                      <NavLink to={"https://martcost.com/profile/"}>
                        https://martcost.com/profile/ (found 1)
                      </NavLink>
                      <br />
                      <NavLink to={"https://martcost.com/support/"}>
                        https://martcost.com/support/ (found 1)
                      </NavLink>
                    </Form.Group>
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> Metadata Information
              </Card.Header>
              <Card.Body className="p-0">
                <ListGroup className="rounded-0">
                  <ListGroup.Item
                    style={{ fontSize: 12 }}
                    className="px-2 border-0 d-flex py-1"
                  >
                    <div
                      className="hstack gap-1 align-items-start fw-bold px-2"
                      style={{ minWidth: 200 }}
                    >
                      Title
                      <FaQuestionCircle
                        className="text-secondary ms-1 CP"
                        style={{ marginTop: 2 }}
                        title="sadf aksdgvgbkasjdg kajdfgn nkx"
                      />
                    </div>
                    <Form.Group className="">
                      <div className="mb-2">
                        Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Perspiciatis, eaque aliquam. Aliquam unde non,
                        dignissimos voluptates nihil eveniet illo incidunt.
                      </div>

                      <div className="hstack justify-content-between">
                        <div className="mb-1">
                          <FaCircleCheck className="text-success me-1" />
                          1% (Recommended: more than 10%)
                        </div>
                        <Badge
                          className="br3 bg-primary px-2 CP"
                          style={{ width: 70 }}
                          title="Solutions Here..."
                          onClick={() =>
                            setOpenSolutions(
                              openSolutions === "tips" ? "" : "tips",
                            )
                          }
                        >
                          Tips!
                        </Badge>
                      </div>
                      <Collapse in={openSolutions === "tips"}>
                        <div className="bg-success-subtle mt-1 mb-2">
                          <Form.Label
                            style={{ fontSize: 12 }}
                            className="mb-1 p-2"
                          >
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Similique dolorem sequi qui, magni magnam
                            quidem deserunt ipsam officiis in aliquam
                            voluptatum, voluptatem maxime possimus odit,
                            expedita quisquam reiciendis excepturi fuga.{" "}
                          </Form.Label>
                        </div>
                      </Collapse>
                      <div className="hstack justify-content-between">
                        <div className="mb-1">
                          <FaCircleXmark className="text-danger me-1" />
                          1% (Recommended: more than 10%)
                        </div>
                        <Badge
                          className="br3 bg-primary px-2 CP"
                          style={{ width: 70 }}
                          title="Solutions Here..."
                          onClick={() =>
                            setOpenSolutions(
                              openSolutions === "fix" ? "" : "fix",
                            )
                          }
                        >
                          How to Fix?
                        </Badge>
                      </div>
                      <Collapse in={openSolutions === "fix"}>
                        <div className="bg-success-subtle mt-1 mb-2">
                          <Form.Label
                            style={{ fontSize: 12 }}
                            className="mb-1 p-2"
                          >
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Similique dolorem sequi qui, magni magnam
                            quidem deserunt ipsam officiis in aliquam
                            voluptatum, voluptatem maxime possimus odit,
                            expedita quisquam reiciendis excepturi fuga.{" "}
                          </Form.Label>
                        </div>
                      </Collapse>
                      <div className="hstack justify-content-between">
                        <div className="mb-1">
                          <FaCircleInfo className="text-warning me-1" />
                          1% (Recommended: more than 10%)
                        </div>
                        <Badge
                          className="br3 bg-primary px-2 CP"
                          style={{ width: 70 }}
                          title="Solutions Here..."
                          onClick={() =>
                            setOpenSolutions(
                              openSolutions === "suggestions"
                                ? ""
                                : "suggestions",
                            )
                          }
                        >
                          Suggestions!
                        </Badge>
                      </div>
                      <Collapse in={openSolutions === "suggestions"}>
                        <div className="bg-success-subtle mt-1 mb-2">
                          <Form.Label
                            style={{ fontSize: 12 }}
                            className="mb-1 p-2"
                          >
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Similique dolorem sequi qui, magni magnam
                            quidem deserunt ipsam officiis in aliquam
                            voluptatum, voluptatem maxime possimus odit,
                            expedita quisquam reiciendis excepturi fuga.{" "}
                          </Form.Label>
                        </div>
                      </Collapse>
                    </Form.Group>
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> Page Quality
              </Card.Header>
              <Card.Body className="p-0">
                <ListGroup className="rounded-0">
                  <ListGroup.Item
                    style={{ fontSize: 12 }}
                    className="px-2 border-0 d-flex py-1"
                  >
                    <div
                      className="hstack gap-1 align-items-start fw-bold px-2"
                      style={{ minWidth: 200 }}
                    >
                      Word Count
                      <FaQuestionCircle
                        className="text-secondary ms-1 CP"
                        style={{ marginTop: 2 }}
                        title="sadf aksdgvgbkasjdg kajdfgn nkx"
                      />
                    </div>
                    <Form.Group className="">
                      <div className="mb-2">
                        Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Perspiciatis, eaque aliquam. Aliquam unde non,
                        dignissimos voluptates nihil eveniet illo incidunt.
                      </div>
                      <div className="hstack gap-2 flex-wrap mb-2">
                        <Badge className="bg-secondary-subtle text-dark px-2 br3">
                          Tag 1
                        </Badge>
                      </div>
                      <div className="hstack justify-content-between">
                        <div className="mb-1">
                          <FaCircleCheck className="text-success me-1" />
                          1% (Recommended: more than 10%)
                        </div>
                        <Badge
                          className="br3 bg-primary px-2 CP"
                          style={{ width: 70 }}
                          title="Solutions Here..."
                          onClick={() =>
                            setOpenSolutions(
                              openSolutions === "tips" ? "" : "tips",
                            )
                          }
                        >
                          Tips!
                        </Badge>
                      </div>
                      <Collapse in={openSolutions === "tips"}>
                        <div className="bg-success-subtle mt-1 mb-2">
                          <Form.Label
                            style={{ fontSize: 12 }}
                            className="mb-1 p-2"
                          >
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Similique dolorem sequi qui, magni magnam
                            quidem deserunt ipsam officiis in aliquam
                            voluptatum, voluptatem maxime possimus odit,
                            expedita quisquam reiciendis excepturi fuga.{" "}
                          </Form.Label>
                        </div>
                      </Collapse>
                      <div className="hstack justify-content-between">
                        <div className="mb-1">
                          <FaCircleXmark className="text-danger me-1" />
                          1% (Recommended: more than 10%)
                        </div>
                        <Badge
                          className="br3 bg-primary px-2 CP"
                          style={{ width: 70 }}
                          title="Solutions Here..."
                          onClick={() =>
                            setOpenSolutions(
                              openSolutions === "fix" ? "" : "fix",
                            )
                          }
                        >
                          How to Fix?
                        </Badge>
                      </div>
                      <Collapse in={openSolutions === "fix"}>
                        <div className="bg-success-subtle mt-1 mb-2">
                          <Form.Label
                            style={{ fontSize: 12 }}
                            className="mb-1 p-2"
                          >
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Similique dolorem sequi qui, magni magnam
                            quidem deserunt ipsam officiis in aliquam
                            voluptatum, voluptatem maxime possimus odit,
                            expedita quisquam reiciendis excepturi fuga.{" "}
                          </Form.Label>
                        </div>
                      </Collapse>
                      <div className="hstack justify-content-between">
                        <div className="mb-1">
                          <FaCircleInfo className="text-warning me-1" />
                          1% (Recommended: more than 10%)
                        </div>
                        <Badge
                          className="br3 bg-primary px-2 CP"
                          style={{ width: 70 }}
                          title="Solutions Here..."
                          onClick={() =>
                            setOpenSolutions(
                              openSolutions === "suggestions"
                                ? ""
                                : "suggestions",
                            )
                          }
                        >
                          Suggestions!
                        </Badge>
                      </div>
                      <Collapse in={openSolutions === "suggestions"}>
                        <div className="bg-success-subtle mt-1 mb-2">
                          <Form.Label
                            style={{ fontSize: 12 }}
                            className="mb-1 p-2"
                          >
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Similique dolorem sequi qui, magni magnam
                            quidem deserunt ipsam officiis in aliquam
                            voluptatum, voluptatem maxime possimus odit,
                            expedita quisquam reiciendis excepturi fuga.{" "}
                          </Form.Label>
                        </div>
                      </Collapse>
                    </Form.Group>
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> Media List
              </Card.Header>
              <Card.Body className="p-0">
                <div className="overflow-auto mb-2" style={{ maxHeight: 200 }}>
                  <Table
                    borderless
                    className="mb-0"
                    style={{ verticalAlign: "middle" }}
                  >
                    <thead
                      className="position-sticky bg-white"
                      style={{ top: -1 }}
                    >
                      <tr>
                        <th>URL</th>
                        <th>Alt Attribute</th>
                        <th>Title</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <a href="https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png">
                            https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png
                          </a>
                        </td>
                        <td>Lorem ipsum </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png">
                            https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png
                          </a>
                        </td>
                        <td>Lorem ipsum </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png">
                            https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png
                          </a>
                        </td>
                        <td>Lorem ipsum </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png">
                            https://rankmath.com/wp-content/themes/rm/images/favicons/favicon-72.png
                          </a>
                        </td>
                        <td>Lorem ipsum </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> Heading Structure
              </Card.Header>
              <Card.Body className="p-0">
                <div className="overflow-auto mb-2" style={{ maxHeight: 200 }}>
                  <Table
                    borderless
                    className="mb-0"
                    style={{ verticalAlign: "middle" }}
                  >
                    <thead
                      className="position-sticky bg-white"
                      style={{ top: -1 }}
                    >
                      <tr>
                        <th>Headign Lavel</th>
                        <th>Content</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H1
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H2
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H3
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Badge className="br3 bg-secondary-subtle text-dark">
                            H4
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> Link Structure
              </Card.Header>
              <Card.Body className="p-0">
                <div className="overflow-auto mb-2" style={{ maxHeight: 200 }}>
                  <Table
                    borderless
                    className="mb-0"
                    style={{ verticalAlign: "middle" }}
                  >
                    <thead
                      className="position-sticky bg-white"
                      style={{ top: -1 }}
                    >
                      <tr>
                        <th>Link</th>
                        <th>Attributes</th>
                        <th>Anchor text</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <a href="http://martcost.com/product">
                            http://martcost.com/product
                          </a>
                        </td>
                        <td>
                          <div className="hstack gap-2 flex-wrap">
                            <Badge className="br3 bg-secondary-subtle text-dark">
                              Anchor
                            </Badge>
                            <Badge className="br3 bg-success-subtle text-dark">
                              Text Duplicate
                            </Badge>
                          </div>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="http://martcost.com/">
                            http://martcost.com/
                          </a>
                        </td>
                        <td>
                          <Badge className="br3 bg-warning-subtle text-dark">
                            Nofollow
                          </Badge>
                        </td>
                        <td>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Header className="border-0" style={{ fontSize: 13 }}>
                <TbTableOptions /> HTTP Response Header
              </Card.Header>
              <Card.Body className="p-0">
                <div className="overflow-auto mb-2" style={{ maxHeight: 200 }}>
                  <Table
                    borderless
                    className="mb-0"
                    style={{ verticalAlign: "middle" }}
                  >
                    <thead
                      className="position-sticky bg-white"
                      style={{ top: -1 }}
                    >
                      <tr>
                        <th>Name</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>date</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>content-type</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>vary</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>x-dlm-no-waypoints</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>x-frame-option</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>link</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>x-onecom-rid</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>x-request-id</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>x-node</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>last-modified</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>cf-cache-status</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>age</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>strict-transport</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>server</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>cf-ray</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>content-encoding</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>statuscode</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                      <tr>
                        <td>http_version</td>
                        <td>Lorem ipsum dolor sit amet.</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Form.Group>
          <Form.Group
            as={Col}
            xs={12}
            md={3}
            className="overflow-auto p-0"
            style={{ height: "calc(100vh - 56px)" }}
          >
            <Form.Label className="text-center mb-0 fw-bold bg-white w-100 py-2">
              Page Score for
            </Form.Label>
            <div className="text-center mt-2">
              <NavLink
                to={"https://martcost.com/"}
                className="text-dark"
                style={{ fontSize: 15 }}
              >
                https://martcost.com/
              </NavLink>
            </div>
            <SEOReportGraph />
            <div className="text-center mt-3">
              <Button
                size="sm"
                style={{ fontSize: 12 }}
                variant="outline-primary"
              >
                Rescan
              </Button>
            </div>
            <div className="w-100 text-center">
              <Form.Label className="mb-0 mt-3 fw-bold bg-white w-100 py-2">
                Website Analytics
              </Form.Label>
              <div className="hstack justify-content-between mt-3 gap-3 px-2">
                <Badge
                  className="bg-danger-subtle text-dark w-100 CP px-2 py-4 br3"
                  title="View Statstics"
                >
                  <span style={{ fontSize: 24 }}>3</span> <br /> Errors
                </Badge>
                <Badge
                  className="bg-warning-subtle text-dark w-100 CP px-2 py-4 br3"
                  title="View Statstics"
                >
                  <span style={{ fontSize: 24 }}>27</span> <br /> Warnings
                </Badge>
                <Badge
                  className="bg-success-subtle text-dark w-100 CP px-2 py-4 br3"
                  title="View Statstics"
                >
                  <span style={{ fontSize: 24 }}>35</span> <br /> passed
                </Badge>
              </div>
            </div>
            <div className="p-2">
              <div className="bg-white br3 p-2">
                <Form.Group className="hstack justify-content-between">
                  <Form.Label className="mb-1">Status code</Form.Label>
                  <Form.Label className="mb-1 text-success">200 OK</Form.Label>
                </Form.Group>
                <Form.Group className="hstack justify-content-between">
                  <Form.Label className="mb-1">Indexation</Form.Label>
                  <Form.Label className="mb-1 text-success">
                    Indexable
                  </Form.Label>
                </Form.Group>
                <Form.Group className="hstack justify-content-between">
                  <Form.Label className="mb-0">Page size</Form.Label>
                  <Form.Label className="mb-0 text-success">1.74 MB</Form.Label>
                </Form.Group>
              </div>
            </div>
          </Form.Group>
        </Row>
      </Container>
    </>
  );
};

export default OnePageSEOChecker;
